import { addValidationRule } from '@akihirotakamura/formsy-react'
import moment from 'moment'

addValidationRule('isDateTime', (values, value) => {
  if (!value || value === '') return true
  const plain = value.toString().replace(/[\u002f\u003a\u0020]/g, '')
  return plain.match(/[0-9]{12}/) && moment(value, 'YYYYMMDDHHmm').isValid()
})
